"use client"

import { Fragment, useEffect, useState } from 'react'
import Carousel from "@/components/common/Carousel"
import NextImage from "@/components/common/NextImage"
import { useDevicePassedWidth } from "@/hooks/app/useDevicePassedWidth"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import { Col, Skeleton } from 'antd'
import { TypeStoreDetail } from '@/lib/redux/features/store/type'

const BannerSkeleton = ({ store }: { store: TypeStoreDetail }) => {
  const isDesktop = useIsDesktop()
  const passedWidth = useDevicePassedWidth(w => w > 1600)

  const [isLargeBanner, setIsLargeBanner] = useState<any>(-1)

  useEffect(() => {
    if (isLargeBanner !== -1) return;
    setIsLargeBanner(passedWidth)
  }, [passedWidth, isLargeBanner])

  if (store.enabled_banner_carousel && !!store?.carousel_banner_data?.length) {
    return (
      <Col span={24}>
        <Skeleton.Image
          style={{
            height: store?.carousel_banner_data[0].height || 2000,
            width: store?.carousel_banner_data[0].width || 2000
          }}
        />
      </Col>
    )
  }

  const validBanner = !!(store.banner?.disabled ? '' : store.banner?.url)
  const validBanner192x1080 = !!(store.banner_1920x1080?.disabled ? '' : store.banner_1920x1080?.url)
  const validBannerMobile = !!(store.banner_mobile?.disabled ? '' : store.banner_mobile?.url)

  const banner = validBanner
    ? store.banner
    : validBanner192x1080
      ? store.banner_1920x1080
      : store.banner_mobile

  const banner1920x1080 = validBanner192x1080
    ? store.banner_1920x1080
    : validBanner
      ? store.banner
      : store.banner_mobile

  const bannerMobile = validBannerMobile
    ? store.banner_mobile
    : validBanner
      ? store.banner
      : store.banner_1920x1080

  const staticBannerData = [
    {
      banner: banner,
      className: "home__banner",
    },
    {
      banner: bannerMobile,
      className: "home__banner--mobile"
    },
    {
      banner: banner1920x1080,
      className: "home__banner--1920x1080"
    }
  ]

  const validBanners = staticBannerData.filter(({ banner, className }) => {
    if (isLargeBanner !== -1) {
      if (isDesktop) {
        if (className === 'home__banner--mobile') {
          return false
        }
        if (isLargeBanner === true) {
          if (className === 'home__banner--mobile' || className === 'home__banner') {
            return false
          }
        } else if (className === 'home__banner--1920x1080') {
          return false
        }
      } else if (className === 'home__banner--1920x1080' || className === 'home__banner') {
        return false
      }
    }
    return !!banner?.url
  })

  if (!validBanners.length) {
    return <Fragment />
  }

  return (
    <Col span={24}>
      {validBanners.map(({ banner, className }) => {
        return (
          <Skeleton.Image
            key={className}
            styles={{
              content: {
                height: banner?.height,
                width: banner?.width,
                maxWidth: '100vw',
                maxHeight: '100vh'
              }
            }}
          />
        )
      })}
    </Col>
  )
}

export default BannerSkeleton